import { makeAutoObservable } from "mobx";

import { CreateTeamDialogStore } from "./CreateTeamDialogStore";
import { ForkDialogStore } from "./ForkDialogStore";
import { ImportFromNotionDialogStore } from "./ImportFromNotionDialogStore";
import { ImportFromOverleafDialogStore } from "./ImportFromOverleafDialogStore";
import { LoginDialogStore } from "./LoginDialogStore";
import { RequestPermissionDialogStore } from "./RequestPermissionDialogStore";
import { ShareDialogStore } from "./ShareDialogStore";
import { TeamDialogStore } from "./TeamDialogStore";
import { UpgradePlanDialogStore } from "./UpgradePlanDialogStore";

import type { RootStore } from "@/store/RootStore";

export class DialogStore {
  rootStore: RootStore;

  forkDialogStore: ForkDialogStore;

  importFromOverleafDialogStore: ImportFromOverleafDialogStore;

  teamDialog: TeamDialogStore;

  createTeamDialog: CreateTeamDialogStore;

  loginDialog: LoginDialogStore;

  shareDialog: ShareDialogStore;

  requestPermissionDialog: RequestPermissionDialogStore;

  importFromNotionDialog: ImportFromNotionDialogStore;

  upgradePlanDialog: UpgradePlanDialogStore;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    this.forkDialogStore = new ForkDialogStore(rootStore);
    this.importFromOverleafDialogStore = new ImportFromOverleafDialogStore(rootStore);
    this.teamDialog = new TeamDialogStore(rootStore);
    this.createTeamDialog = new CreateTeamDialogStore(rootStore);
    this.loginDialog = new LoginDialogStore(rootStore);
    this.shareDialog = new ShareDialogStore(rootStore);
    this.requestPermissionDialog = new RequestPermissionDialogStore(rootStore);
    this.importFromNotionDialog = new ImportFromNotionDialogStore(rootStore);
    this.upgradePlanDialog = new UpgradePlanDialogStore(rootStore);

    makeAutoObservable(this);
  }
}
